import type { FaireProductEntity } from "../../entity_types/product";

export const p_pxuw99p8f2: FaireProductEntity = {
  token: "p_pxuw99p8f2",
  type: "product",
  name: "Elephant Print Wool Harem Hippie Unisex  Pant",
  brandToken: "b_7rkbvdp47b",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/34b8b2173ce05ebdcddcaafd01a61acf2585077c2bb1acf28e240eb2873e79fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0daa4d53829ad636923ada66b1acc365e72ad90645172a45e18a502e98cba1f1.jpeg",
    "https://cdn.faire.com/fastly/2296bbd31e63dccf45eb0162bc4a9905b7714be8785cb95452c63ecdf22e6f6b.jpeg",
    "https://cdn.faire.com/fastly/6de3079c012490e07476a3e3b1a6bcf5c8fad925742005a85869ad27bab3819e.jpeg",
    "https://cdn.faire.com/fastly/1bc85b52cfde60666386e41f1fc0842df9580f0d6d15c90c4696a51f2fb9508c.jpeg",
    "https://cdn.faire.com/fastly/d68d303f92a051ed7cfa8456a5805eb3569de33735e19ad31628ab3c8e43ac20.jpeg",
    "https://cdn.faire.com/fastly/6f008a17d5d4aa9f129eb098ed716c65509ff29082b323b9a2d65fc678fb263c.jpeg",
    "https://cdn.faire.com/fastly/c22deb49556da0a2f2da12cd59a897e50479f2f391aae09c13ebd2f7ed502544.jpeg",
    "https://cdn.faire.com/fastly/3a693b1bc4eafdd11bab79f7a12ec06938c58880b7fdb4396880840ebf7689d0.jpeg",
    "https://cdn.faire.com/fastly/56c6de73c90f18c07632821913dfeaece79c9b56f9349285f1699f408ce2d072.jpeg",
  ],
  priceDollars: 34.64,
  description:
    'Make a statement in these Elephant Print Harem Pants. Handmade from a wool blend, these warm winter pants feature an elephant print in earth tones for a stylish, boho look. The unisex design consists of a loose fit, elastic waist, and hippie-style trousers for a truly unique look. Perfect for casual outings, yoga, and more.\n\nHandmade in Nepal\n\nMaterial: Wool, Cashmere, Cotton\n\nAdjustable Waist\n\nSize: One Size; Fits up to US Size XL\n\nWaist:  Approx.19" to 38"\n\nHips:  Approx.20" to 40"\n\nLength:  Approx. 40"\n\nUnisexual\n\nTwo side pockets\n\nNon-Itchy material\n\nThis  Wool pant has the adjustable waist with elastic and fits most sizes and is perfect for practicing yoga, dancing and can be dressed up. And it is perfect to keep you warm and cozy in the winter.\n\n**FAIR TRADE\n**ETHICALLY SOURCED\n**SUSTAINABLE FASHION',
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:16.583Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
